import * as cardsApi from '@/network/api/cards/cards.api.js'
import * as corebankingApi from '@/network/api/cards/corebanking.api.js'
import * as apiAccount from '@/network/api/accounts.api.js'
import * as apiAgencies from '@/network/api/agencies.api.js'
import * as apiBranches from '@/network/api/branches.api.js'

/** requests Cards Type List
@return {promise} - Cards Type List request
*/
export const requestCardsTypeList = async (context, payload) => {
    const res = await cardsApi.getCardsType(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_CARDS_TYPE_LIST', data)
    }
    return res
}

/** Validates Cards Quantity for request
@return {promise} - Cards Type List request
*/
export const validateQuantityForRequest = async (context, payload) => {
    const res = await cardsApi.validateQuantityForRequest(payload)
    return res
}

/** Creates New Card
@return {promise} - New Card Request
*/
export const requestNewCard = async (context, payload) => {
    const res = await corebankingApi.requestNewCard(payload)
    return res
}

/** requests Meta Data
@return {promise} - Meta Data request
*/
export const getMetadataForCardRequest = async (context, payload) => {
    const res = await corebankingApi.getMetadataForCardRequest(payload)

    if (res) context.commit('SAVE_METADATA_CARD_REQUEST', res.data.data)

    return res
}

/** Creates New Card Solicitation
@return {promise} - New Card Solicitation
*/
export const requestNewCardSolicitation = async (context, payload) => {
    const res = await cardsApi.requestNewCardSolicitation(payload)
    return res
}

/** Requests Card Comissions
@return {promise} - Card Comissions
*/
export const getCardCommissions = async (context, payload) => {
    const res = await cardsApi.getCardCommissions(payload)

    if (res) context.commit('SAVE_CARD_COMISSIONS', res.data.data)
    return res
}

/** requests Accounts Balance
@return { promise } - Accounts Balance request
*/
export const requestAccountsBalances = async (context, payload) => {
    const res = await apiAccount.requestAccountsBalances(payload)

    if (res) context.commit('SAVE_ACCOUNTS_BALANCE', res.data.data)
    return res
}

/** requests agencies provinces
@return { promise } - Agencies Provinces request
*/
export const requestAgenciesProvinces = async (context, payload) => {
    const res = await apiAgencies.requestAgenciesProvinces(payload)
    if (res) context.commit('SAVE_AGENCIES_PROVINCES', res.data.data)
    return res
}

/** requests branches
@return { promise } - Branches list request
*/
export const requestBranches = async (context, payload) => {
    const res = await apiBranches.requestBranchesList(payload)

    if (res) context.commit('SAVE_BRANCHES', res.data.data)
    return res
}
